import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=b5be4f64&"
import script from "./Issues.vue?vue&type=script&lang=ts&"
export * from "./Issues.vue?vue&type=script&lang=ts&"
import style0 from "./Issues.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5be4f64')) {
      api.createRecord('b5be4f64', component.options)
    } else {
      api.reload('b5be4f64', component.options)
    }
    module.hot.accept("./Issues.vue?vue&type=template&id=b5be4f64&", function () {
      api.rerender('b5be4f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/issues/Issues.vue"
export default component.exports